import React from 'react'

import { PositionDetails } from 'types/position'
import { GridContainerForPositionV3 } from './styled'
import ListItem from './PositionListItem/index'
import TagButton from 'components/TagButton'

export type PositionListProps = React.PropsWithChildren<{
  positions: PositionDetails[]
}>

export default function PositionList({ positions }: PositionListProps) {
  const [inRange, setInRange] = React.useState(true)
  const [outOfRange, setOutOfRange] = React.useState(false)
  const [inactive, setInactive] = React.useState(false)

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '16px' }}>
        <TagButton
          active={inRange}
          onClick={() => setInRange(!inRange)}
          style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#27AE60"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M9 12l2 2l4 -4" />
          </svg>
          In range
        </TagButton>
        <TagButton
          active={outOfRange}
          onClick={() => setOutOfRange(!outOfRange)}
          style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff8f00"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-circle-x"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M10 10l4 4m0 -4l-4 4" />
          </svg>
          Out of range
        </TagButton>
        <TagButton
          active={inactive}
          onClick={() => setInactive(!inactive)}
          style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FD4040"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-cancel"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M18.364 5.636l-12.728 12.728" />
          </svg>
          Inactive
        </TagButton>
      </div>

      <GridContainerForPositionV3>
        {positions.map((p) => {
          return (
            <ListItem
              key={p.tokenId.toString()}
              positionDetails={p}
              inRange={inRange}
              outOfRange={outOfRange}
              inactive={inactive}
            />
          )
        })}
      </GridContainerForPositionV3>
      {/*    <AutoColumn justify={'center'} gap="md">
        <Text textAlign="center" fontSize={14} style={{ padding: '.5rem 0 .5rem 0', marginTop: '14px' }}>
          {'Want to migrate your V2 Liquidity?'}{' '}
          <StyledInternalLink id="migrate-pool-link" to={'/migrate/v2'}>
            {'Migrate V2 liquidity.'}
          </StyledInternalLink>
        </Text>
      </AutoColumn> */}
    </>
  )
}
